import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronRight, FolderOpen, Server, SquareTerminal } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { useGraphUiStore } from '../../graph/graphUiStore';
import { openHostInSftp, openHostInTerminal } from '../../graph/sshHostActions';

/**
 * "How do you want to open this host?" — shown when an SSH/SFTP host is opened
 * from the Graph or a Project. Two clear choices, each of which really
 * connects (not just switches page). Mounted by GraphView and ProjectsTab;
 * the request travels through graphUiStore so either page can raise it.
 */
export default function SshHostChoiceModal() {
  const { t } = useTranslation();
  const node = useGraphUiStore((s) => s.sshChoice);
  const close = useGraphUiStore((s) => s.clearSshChoice);
  if (!node) return null;
  const connId = node.id.slice('ssh_host:'.length);

  const pick = (fn) => {
    close();
    fn();
  };

  return (
    <Modal isOpen onClose={close} title={t('graph.ssh.title', { name: node.label })} subtitle={t('graph.ssh.subtitle')} customIcon={<Server size={18} />}>
      <div className="ssh-choice" role="group" aria-label={t('graph.ssh.subtitle')}>
        <button type="button" className="ssh-choice-option" autoFocus onClick={() => pick(() => openHostInSftp(connId))}>
          <span className="ssh-choice-icon ssh-choice-icon--files" aria-hidden>
            <FolderOpen size={20} />
          </span>
          <span className="ssh-choice-text">
            <span className="ssh-choice-title">{t('graph.ssh.filesTitle')}</span>
            <span className="ssh-choice-desc">{t('graph.ssh.filesDesc')}</span>
          </span>
          <ChevronRight size={16} className="ssh-choice-chevron" aria-hidden />
        </button>
        <button type="button" className="ssh-choice-option" onClick={() => pick(() => openHostInTerminal(connId, node.label))}>
          <span className="ssh-choice-icon ssh-choice-icon--terminal" aria-hidden>
            <SquareTerminal size={20} />
          </span>
          <span className="ssh-choice-text">
            <span className="ssh-choice-title">{t('graph.ssh.terminalTitle')}</span>
            <span className="ssh-choice-desc">{t('graph.ssh.terminalDesc')}</span>
          </span>
          <ChevronRight size={16} className="ssh-choice-chevron" aria-hidden />
        </button>
      </div>
    </Modal>
  );
}
